import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-5 flex flex-col flex-grow gap-2" }
const _hoisted_2 = { class: "flex flex-col flex-grow gap-2" }
const _hoisted_3 = { class: "flex flex-col w-full gap-2 flex-grow" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "flex gap-1 justify-between items-center" }
const _hoisted_9 = ["href"]

import {onMounted, ref} from "vue";
import {query, type IdName} from "@/graphql";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExcelExportInfo',
  props: {
  magazineId: {
    type: Number,
    default: 0
  },
  projectId: {
    type: Number,
    default: 0
  }
},
  setup(__props) {



const props = __props;

const projectId = ref<number>(0);
const magazineId = ref<number>(0);
const projects = ref([] as IdName[]);
const magazines = ref([] as IdName[]);

onMounted(async () => {
  projectId.value = props.projectId;
  await getProjectsWithIdAndName();
  magazineId.value = props.magazineId;

  await getMagazinesWithIdAndName();

});

function changeProjects() {
  magazineId.value = 0;
  getMagazinesWithIdAndName();
}
async function getProjectsWithIdAndName() {
  const [data, err] = await query.getProjectsWithIdAndName();
  projects.value = data;
  if (err) {
    console.error(err);
    return;
  }
}

async function getMagazinesWithIdAndName() {
  const [data, err] = await query.getMagazinesWithIdAndName(projectId.value);
  magazines.value = data;
  if (err) {
    console.error(err);
    return;
  }
}

function excelExport() {
  
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "flex flex-col text-black pb-5" }, [
      _createElementVNode("h2", { class: "text-2xl font-bold" }, " Excel Export Info"),
      _createElementVNode("span", { class: "text-md" }, "Dies ist der Excel-Export. Bitte wählen Sie ein Magazine aus, das Sie Exportieren möchten. "),
      _createElementVNode("span", { class: "text-md" }, "Sie können normale sowie auch regionale Magazine Exportieren.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "p-1 w-[150px]" }, "Projekt:", -1)),
          _withDirectives(_createElementVNode("select", {
            onChange: changeProjects,
            class: "outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2 text-gray-500",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((projectId).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projects.value, (project) => {
              return (_openBlock(), _createElementBlock("option", {
                key: project.id,
                value: project.id
              }, _toDisplayString(project.name), 9, _hoisted_5))
            }), 128))
          ], 544), [
            [_vModelSelect, projectId.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "p-1 w-[150px]" }, "Magazine:", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((magazineId).value = $event)),
            class: "outline-0 border border-bg-trader-input-border border-header p-1 w-full shadow-inner-2 text-gray-500"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(magazines.value, (magazine) => {
              return (_openBlock(), _createElementBlock("option", {
                key: magazine.id,
                value: magazine.id
              }, _toDisplayString(magazine.name), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, magazineId.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[4] || (_cache[4] = _createElementVNode("button", { class: "text-center bg-trader-dark-gray hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px]" }, " Abbrechen ", -1)),
      _createElementVNode("a", {
        onClick: excelExport,
        href: `/api/v3/excel/magazine/${magazineId.value}`,
        target: "_blank",
        class: "text-trader-dark-red text-center bg-trader-red hover:bg-trader-blue hover:text-white rounded p-2 min-w-[150px] cursor-pointer"
      }, " Excel Export ", 8, _hoisted_9)
    ])
  ]))
}
}

})